import { Button, Menu, MenuItem, Typography, alpha } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";

export default function NavigationItem({ page, navigate, location, theme }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const isActive = location.pathname === page.path;

  /*
  const isChildActive = page.children?.some(
    (child) => child.path === location.pathname,
  );
*/
  if (!page.children) {
    return (
      <Button
        startIcon={page.icon}
        onClick={() => navigate(page.path)}
        disableRipple
        sx={{
          color: isActive ? "primary.main" : "text.secondary",
          fontWeight: isActive ? 600 : 500,
          textTransform: "none",
          fontSize: "0.9rem",
          px: 2,
          py: 0.8,
          borderRadius: "10px",
          backgroundColor: isActive
            ? alpha(theme.palette.primary.main, 0.08)
            : "transparent",
        }}
      >
        {page.title}
      </Button>
    );
  }

  return (
    <>
      <Button
        startIcon={page.icon}
        endIcon={<ExpandMoreIcon />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        disableRipple
        sx={{
          textTransform: "none",
          fontWeight: 500,
          fontSize: "0.9rem",
          px: 2,
          py: 0.8,
          borderRadius: "10px",
          color: "text.secondary",
          backgroundColor: "transparent",
          "&:hover": {
            backgroundColor: alpha(theme.palette.primary.main, 0.06),
          },
        }}
      >
        {page.title}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        PaperProps={{
          sx: {
            mt: 1,
            borderRadius: "12px",
            minWidth: 240,
            boxShadow: "0 8px 24px rgba(0,0,0,0.10)",
          },
        }}
      >
        {page.children.map((child) => {
          const active = location.pathname === child.path;

          return (
            <MenuItem
              key={child.title}
              selected={active}
              onClick={() => {
                navigate(child.path);
                setAnchorEl(null);
              }}
              sx={{
                py: 1.2,
                px: 2,
                gap: 1,
                "&.Mui-selected": {
                  backgroundColor: alpha(theme.palette.primary.main, 0.1),
                  color: "primary.main",
                },
                "&.Mui-selected:hover": {
                  backgroundColor: alpha(theme.palette.primary.main, 0.16),
                },
              }}
            >
              {child.icon}
              <Typography variant="body2" fontWeight={active ? 600 : 400}>
                {child.title}
              </Typography>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
